import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router';

import Notifications from '@components/ui/notifications/Notifications.tsx';
import { Provider } from 'jotai';

import { QueryProvider } from '@/lib/query-client/react-query';
import { store } from '@/state/store.ts';

import { AppProvider } from './AppProvider';
import { AppRoutes } from './AppRoutes';

function ErrorFallback({ error }: { error: Error }) {
  return (
    <div role="alert" style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Something went wrong:</h2>
      <pre style={{ color: 'red' }}>{error.message}</pre>
      <button onClick={() => window.location.reload()}>Reload Page</button>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Provider store={store}>
        <QueryProvider>
          <AppProvider>
            <BrowserRouter>
              <AppRoutes />
              <Notifications />
            </BrowserRouter>
          </AppProvider>
        </QueryProvider>
      </Provider>
    </ErrorBoundary>
  );
}
